import '../styles/TermsComponent.css';
import { Link } from 'react-router-dom';

const TermsComponent = ({ termsContent, lang }) => {
    if (!termsContent || !termsContent.terms || termsContent.terms.length === 0) {
        return (
            <div className="col" id="terms-container">
                <div className="row" id="terms-header">
                    <h1>{lang === 'en' ? 'Terms of Service' : 'Termeni și Condiții' }</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="col" id="terms-container">
            <div className="row" id="terms-header">
                <h1>{lang === 'en' ? 'Terms of Service' : 'Termeni și Condiții'}</h1>
            </div>

            <div className="row" id="solutions">
            {termsContent.terms.map((term, index) => {
                    // normalize term.descriptions to always be an array
                    let descriptions = [];

                    if (Array.isArray(term.descriptions)) {
                        descriptions = term.descriptions.filter(
                            (desc, i, self) => desc && self.indexOf(desc) === i // remove duplicates + skip empty
                        );
                    } else if (typeof term.descriptions === 'string' && term.descriptions.trim() !== '') {
                        descriptions = [term.descriptions];
                    }

                    return (
                        <div key={term.key || index} className="term-item">
                            <h2>{term.title}</h2>
                            {descriptions.map((desc, i) => (
                                <p key={i}>{desc}</p>
                            ))}
                        </div>
                    );
                })}
            </div>

            <div className="row info" id="solutions" style={{ textAlign: "left" }}>
                <div className="col" style={{ textAlign: "left" }}>
                    <p>©Copyright CONNEXIS Software S.R.L. 2025</p>
                    <p>CONNEXIS Software S.R.L.</p>
                </div>
                <div className="col" style={{ textAlign: "left" }}>
                    <p>Strada Vulcanei Nr.2 CP: 023285 Sector 2 Bucuresti</p>
                    <p>+40 723 71 51 13</p>
                </div>
                <div className="col" style={{ textAlign: "right" }}>
                    <p>office@connexis.ro</p>
                    <p>
                        <Link to="/" style={{color: '#ffffff'}}>
                            www.connexis.ro
                        </Link>
                    </p>

                </div>
                <div className="col" style={{textAlign: "right"}}>
                    <p>RO 36323100</p>
                    <p>J40/9680/18.07.2016</p>
                </div>
            </div>
        </div>
    );
};

export default TermsComponent;
